module.exports = "/_next/static/images/CollectionCloudSources@2x-6f2c8c36f2a999412d41ed3b483f5192.png";